import { render, staticRenderFns } from "./MobileStep2.vue?vue&type=template&id=3029fd44&scoped=true&"
import script from "./MobileStep2.vue?vue&type=script&lang=js&"
export * from "./MobileStep2.vue?vue&type=script&lang=js&"
import style0 from "./MobileStep2.vue?vue&type=style&index=0&id=3029fd44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.6_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3029fd44",
  null
  
)

export default component.exports